export const activityType = 'activitytype'
export const destcity = 'destinationInput'
export const bkgType = 'bookingTypeInput'
export const closeButton = 'closeButton'
export const destbranch = 'destBranchInput'
export const manualLR = 'manualLR'
export const consignerCheck = 'consingerCheckbox'
export const sendMobNo = 'sendMobNo'
export const consignerAt = 'consingerAutoComplete'
export const sendName = 'sendName'
export const sendAdress = 'senderCityAndState'
export const consigneeCheck = 'consgineeCheck'
export const recMobNo = 'recMobNo'
export const recName = 'recName'
export const consigneeAt = 'consingeeAutoComplete'
export const recAddress = 'receiverCityAndState'
export const secAddress = 'senderCityAndState'
export const senGstnNo = 'senGstnNo'
export const recGstnNo = 'recGstnNo'
export const eWayBillNo = 'eWayBillNo'
export const ewaybillNoInput = 'ewaybillPopUpInput'
export const ewayBillFetch = 'ewayBillFetch'
export const checkboxWbList = 'checkbox_ewb_'
export const cancelEwayBilPage = 'cancelEwayBilPage'
export const saveEwayBillPage = 'saveEwayBillPage'
export const senderIdtype = 'senderIdType'
export const senIdProof = 'senIdProof'
export const recIdProof = 'recIdProof'
export const sendIdpreview = 'sendIdpreview'
export const sendIdCameraButton = 'sendIdCameraButton'
export const senderIdSave = 'senderIdSaveButton'
export const senderIdControl = 'senderIdControl'
export const imageUploadcontrol = 'imageUploadcontrol'
export const sendMobNo2 = 'sendMobNo2'
export const recMobNo2 = 'recMobNo2'
export const sendMailId = 'sendMailId'
export const recMailId = 'recMailId'
export const billNumber = 'billNumber'
export const BillDate = 'billDate'
export const billAmount = 'billAmount'
export const consignmentType = 'idForConsignmentType'
export const description = 'idForDescription'
export const packMethod = 'idForPackMethod'
export const unit = 'idForUnit'
export const goodsValue = 'idForGoodsValue'
export const weightActual = 'idForWeightActual'
export const weightVolume = 'idForVolumetricWeight'
export const weightCharged = 'idForWeightCharged'
export const rate = 'idForConsignmentRate'
export const freight = 'idForConsignmentFreight'
export const addRemove = 'idForAddOrRemoveBtton'
export const TotalFreight = 'freight'
export const collCartage = 'coll_cartage'
export const delCartage = 'del_cartage'
export const hamali = 'hamali'
export const opHamali = 'op_hamali'
export const valuation = 'valuation'
export const docFee = 'doc_fee'
export const pickupFee = 'pickup_fee'
export const dropoffFee = 'dropoff_fee'
export const gst = 'gst'
export const cCartageRemark = 'collectionCartageRemark'
export const referanceID = 'bookingreferanceID'
export const additionalChrg = 'bookingAdditionalChrg'
export const accountNo = 'accountNo'
export const comment = 'commentOnBooking'
export const paymentMethod = 'methodOfPayment'
export const focApprovSelect = 'SelectFocApprovers'
export const bookCargo = 'bookCargoButton'
export const pickupAddress = 'pickupAddress'
export const senderpinCode = 'senderPincode'
export const deliveryAddress = 'deliveryAddress'
export const receiverPincode = 'receiverPincode'
export const gmapInputId = 'gmapInputId'
export const houseNo = 'houseNo'
export const apartment = 'apartment'
export const howToReach = 'howToReach'
export const selectPayment = 'idForSelectPayment'
export const selectSearchBy = 'idForSelectSearchBy'
export const selectInput = 'idForSelectInput'
export const searchLrButton = 'idForSearchLrButton'
export const selectLrTracking = 'idForSelectLrTracking'
export const senderName = 'senderName'
export const selectAction = 'selectAction'
export const goButton = 'goButton'
export const senderEmail = 'senderEmail'
export const bookingCity = 'bookingCity'
export const manualLr = 'manualLr'

export const SenderMobileNo = 'SenderMobileNo'

export const SenderGSTN = 'SenderGSTN'

export const bookingBranchName = 'bookingBranchName'

export const paymentTypes = 'paymentTypes'

export const RecName = 'RecName'

export const ReceiverEmailID = 'ReceiverEmailID'
export const destinationCity = 'destCityForAdminUpdate'
export const challanNo = 'challanNo'
export const RecMobileNo = 'RecMobileNo'
export const ReceiverGSTN = 'ReceiverGSTN'
export const demurage = 'demurage'
export const updateButton = 'updateButton'
//rechargeList element Id
export const IntrumentDate = 'instumentDate'
export const TransactionDate = 'transactionDate'
export const BranchList = 'branchList'
export const PartyList = 'partyList'
export const Amount = 'amount'
export const Remark = 'remark'
export const SaveCreditDebitButton = 'saveCreditDebitButton'
export const EditRechageSave = 'editRechageSave'
export const RechargePaymentMode = 'rechargePaymentMode'
export const InstrumentNo = 'instrumentNo'
export const BankName = 'bankName'
